import {useAuth0} from '@auth0/auth0-react'
import {Menu} from '@mantine/core'
import {IconCash} from '@tabler/icons-react'
import {Link} from 'react-router-dom'
import {routes} from '../../../routes.ts'

export const SubscriptionMenuItem = () => {
  const {isAuthenticated} = useAuth0()

  return (
    <Menu.Item
      leftSection={<IconCash stroke={1} />}
      component={Link}
      to={routes.subscriptions.root.buildRoute()}
      disabled={!isAuthenticated}
    >
      Subscription
    </Menu.Item>
  )
}
